import * as React from 'react';
import Modal, { ModalBody, ModalHeader, ModalScrollFooter, ModalSize } from '@kvika/modal';
import Button from '@kvika/button';
import { DirectionDown } from '@kvika/icons';
import { Colors, MediaQuery } from '@kvika/theme';
import { useMediaQuery } from '@kvika/hooks';
import { StyledScrollButtonText, StyledScrollButton, StyledTermDescription, StyledButtonWrapper, } from '../styles/TermStyles';
var TermModal = function (_a) {
    var title = _a.title, renderDescription = _a.renderDescription, goToBottomText = _a.goToBottomText, buttonText = _a.buttonText, testId = _a.testId, onAccept = _a.onAccept, className = _a.className, setIsOpen = _a.setIsOpen, isOpen = _a.isOpen;
    var bodyRef = React.useRef(null);
    var _b = React.useState(false), atBottom = _b[0], setAtBottom = _b[1];
    var _c = React.useState(true), scrollBarShown = _c[0], setScrollbarShown = _c[1];
    var isMobile = useMediaQuery("(max-width: ".concat(MediaQuery.Mobile, ")"));
    var handleConfirmClick = function () {
        setIsOpen(false);
        if (onAccept) {
            onAccept();
        }
    };
    var onScroll = function (e) {
        var target = e.target;
        var margin = 50;
        var isCloseToBottom = target.scrollHeight - (target.scrollTop + target.clientHeight) <= margin;
        setAtBottom(isCloseToBottom);
    };
    React.useEffect(function () {
        var _a, _b;
        if (bodyRef && bodyRef.current) {
            setScrollbarShown(((_a = bodyRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) > ((_b = bodyRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight));
        }
    }, [bodyRef]);
    return (React.createElement(Modal, { "data-testid": "modal-".concat(testId), className: className, isVisible: isOpen, onClose: function () { return setIsOpen(false); }, size: ModalSize.LARGE },
        React.createElement(ModalHeader, null, title),
        React.createElement(ModalBody, { ref: bodyRef, onScroll: onScroll },
            React.createElement(StyledTermDescription, null,
                renderDescription(),
                React.createElement(StyledButtonWrapper, null,
                    React.createElement(Button, { width: isMobile ? '100%' : '224px', onClick: handleConfirmClick, testId: "confirm-button-".concat(testId) }, buttonText)))),
        !atBottom && scrollBarShown && (React.createElement(ModalScrollFooter, null,
            React.createElement(StyledScrollButton, { onClick: function () {
                    if (bodyRef && bodyRef.current) {
                        bodyRef.current.scrollTo(0, bodyRef.current.scrollHeight);
                    }
                }, "data-testid": "scroll-button-".concat(testId) },
                React.createElement(DirectionDown, { color: Colors.gold550 }),
                React.createElement(StyledScrollButtonText, null, goToBottomText))))));
};
export default TermModal;
//# sourceMappingURL=TermModal.js.map